import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const CodeSnippet = ({ code, label, language, maxHeightClassName = 'max-h-64', className, }) => {
    const heading = [label, language].filter(Boolean).join(' · ');
    return (_jsxs("div", { className: ['overflow-hidden rounded-lg border border-border', className]
            .filter(Boolean)
            .join(' '), children: [heading && (_jsxs("div", { className: "flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-semibold text-muted-foreground", children: [_jsx("span", { className: "font-mono font-bold", children: "</>" }), _jsx("span", { className: "truncate", children: heading })] })), _jsx("pre", { className: [
                    'overflow-auto bg-[#1e1e1e] p-3 text-left text-xs leading-relaxed text-gray-100',
                    maxHeightClassName,
                ]
                    .filter(Boolean)
                    .join(' '), children: _jsx("code", { className: "whitespace-pre font-mono", children: code }) })] }));
};
export default CodeSnippet;
